<div class="media">
    <a [routerLink]="['//shop/product/', product.id, product.UnitOfMeasure]">
        <img [defaultImage]="ImageSrc ? ImageSrc : 'assets/images/product/placeholder.jpg'" 
             [lazyLoad]="ImageSrc ? ImageSrc : product.images[0].small"  
             class="img-fluid lazy-loading" alt="{{ product.images[0].alt }}">
    </a>
	<div class="media-body align-self-center">
		<div class="rating">
			<bar-rating [rate]="5" [readOnly]="true"></bar-rating>
		</div>
        <a [routerLink]="['//shop/product/', product.id, product.UnitOfMeasure]">
            <h6>{{ product.title | titlecase }}</h6>
        </a>
		<h4>        {{ product?.newPrice | currency:currency?.currency:'symbol' }}
            <del *ngIf="product?.discount"><span class="money"> {{ product?.price | currency:currency?.currency:'symbol' }}</span></del></h4>
        <ul class="color-variant">
            <li [class]="color" 
                *ngFor="let color of Color(product?.variants)" 
                [ngStyle]="{'background-color': color}"
                (click)="ChangeVariants(color, product)">
            </li>
        </ul>
	</div>
</div>